<template>
  <div

      class="mt-1 mb-1"
      :style="'color:'+content.text_color+'; position:relative;'">
    <div
        v-if="!modifying_theme"
        v-on:mouseenter="text_options = true"
        v-on:mouseleave="text_options = false"
        class="text-content" :class="{'text--shadow-1': content.shadow}">

      <blocks-functions-text
          :close_function="close_text_opts"
          :item="content">
      </blocks-functions-text>

      <global-functions-wizy-wig :model="content" :model_key="'content'" />
    </div>

  </div>
</template>

<script>

import {mapGetters} from "vuex";
import BlocksFunctionsText from "@/components/Blocks/Functions/Text";
import GlobalFunctionsWizyWig from "@/components/Global/Functions/WizyWig";

export default {
  props: {
    content: Object,
  },
  components: {
    BlocksFunctionsText,
    GlobalFunctionsWizyWig
  },
  watch: {
    'toggle_multiple': function(nv) {
      if(nv) {

      }
    }
  },
  computed: {
    ...mapGetters([
      'theme_colors',
      'theme_fonts',
      'selected_theme',
        'modifying_theme',
    ])
  },
  data() {
    return {
      padding_top: 0,
      text_options: false,
      toggle_multiple: [0],
    }
  },
  methods: {
    open_text_options() {
      this.padding_top = 30;
      this.text_options = true;
    },
    close_text_opts() {
      this.padding_top = 0;
      this.text_options = false;
    }
  }

}
</script>

<style lang="scss">
  .shadow-select-bar {
    position: absolute;
    top:-15px;
    right:15px;
    width:35px;
    height:20px;
    .v-btn.v-size--small {
      height: 20px;
      min-width: 35px;
      i {
        font-size:12px;
      }
    }
  }
  .text--shadow-1 {
    text-shadow: 2px 3px 2px rgba(150, 150, 150, 1);
  }
</style>

